import { createSlice, createSelector } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { StandardObject } from "utils";

interface TablePageItem {
  pageSize: number;
  pageNumber: number;
  property: string;
  isAscSorted: boolean;
}

interface TableState {
  tablePageMap: StandardObject<TablePageItem>;
}

interface SetTablePageItemPayload extends TablePageItem {
  key: string;
}

const initialState: TableState = {
  tablePageMap: {},
};

export const tableSlice = createSlice({
  name: "table",
  initialState,
  reducers: {
    setTablePageItem: (state, action: PayloadAction<SetTablePageItemPayload>) => {
      const { key, pageSize, pageNumber, property, isAscSorted } = action.payload;
      state.tablePageMap[key] = {
        pageSize,
        pageNumber,
        property,
        isAscSorted,
      };
    },
  },
});

const selectTable = (state: { table: TableState }) => state.table;

export const selectTableState = createSelector(
  [selectTable],
  (s: TableState) => {
    return {
      tablePageMap: s.tablePageMap,
    };
  }
);

export const { setTablePageItem } = tableSlice.actions;

export default tableSlice.reducer;
